var plugins = [{
      plugin: require('/codebuild/output/src864442118/src/node_modules/gatsby-plugin-page-transitions/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/codebuild/output/src864442118/src/node_modules/gatsby-plugin-nprogress/gatsby-browser'),
      options: {"plugins":[],"color":"#EE3123","showSpinner":false},
    },{
      plugin: require('/codebuild/output/src864442118/src/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-105419653-1","head":true},
    },{
      plugin: require('/codebuild/output/src864442118/src/plugins/gatsby-plugin-lunr-with-arabic/gatsby-browser'),
      options: {"plugins":[],"languages":[{"name":"en"},{"name":"ar"}],"fields":[{"name":"id","store":true,"attributes":{"boost":20}},{"name":"title","store":true,"attributes":{"boost":20}},{"name":"content","store":true},{"name":"url","store":true},{"name":"type","store":true},{"name":"searchBody","store":true}],"resolvers":{"ContentfulPage":{},"ContentfulContentArticle":{},"ContentfulContentNews":{},"ContentfulContentJobPost":{}}},
    }]
// During bootstrap, we write requires at top of this file which looks
// basically like:
// var plugins = [
//   {
//     plugin: require("/path/to/plugin1/gatsby-browser.js"),
//     options: { ... },
//   },
//   {
//     plugin: require("/path/to/plugin2/gatsby-browser.js"),
//     options: { ... },
//   },
// ]

export function apiRunner(api, args, defaultReturn) {
  let results = plugins.map(plugin => {
    if (plugin.plugin[api]) {
      const result = plugin.plugin[api](args, plugin.options)
      return result
    }
  })

  // Filter out undefined results.
  results = results.filter(result => typeof result !== `undefined`)

  if (results.length > 0) {
    return results
  } else if (defaultReturn) {
    return [defaultReturn]
  } else {
    return []
  }
}

export function apiRunnerAsync(api, args, defaultReturn) {
  return plugins.reduce(
    (previous, next) =>
      next.plugin[api]
        ? previous.then(() => next.plugin[api](args, next.options))
        : previous,
    Promise.resolve()
  )
}



// WEBPACK FOOTER //
// ./.cache/api-runner-browser.js